<template>
  <div class="user-cta">
    <Icon name="grClockForward" width="36" class="mb-3"/>
    <div class="mb-5">
      <h4 class="user-cta__title">{{ $t('pages.checkins.selfie_uploading_message') }}</h4>
      <h5 class="user-cta__subtitle">{{ $t('pages.checkins.selfie_uploading_message_subtitle') }}</h5>
    </div>
    <b-button :to="{ name: 'checkins-list'}" variant="primary" class="btn-icon">
      <Icon name="arrowLeft" width="22"/>
      {{ $t('pages.checkins.btn_back_to_home') }}
    </b-button>
  </div>
</template>

<script>
export default {
  name: "CtaUploading",
  props: {
    eventName: {
      type: String,
      required: true
    },
    picaCode: {
      type: String,
      required: true
    }
  }
}
</script>


<style scoped>

</style>